import { render, staticRenderFns } from "./product-vac-config-modal.vue?vue&type=template&id=0342368d&"
import script from "./product-vac-config-modal.vue?vue&type=script&lang=js&"
export * from "./product-vac-config-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports